










import { Component, Vue } from 'vue-property-decorator'
import cities from '@/assets/js/cities.ts'
import axios from 'axios'

interface City {
  name: string;
  cities: {
    name: string;
    countries: string[];
  }[];
}

function transformData(cities: City[]) {
  return cities.map(province => ({
    label: province.name,
    value: province.name,
    children: province.cities.map(city => ({
      label: city.name,
      value: city.name,
      children: city.countries.map(country => ({
        label: country,
        value: country
      }))
    }))
  }))
}

const cityProvince = ['北京市', '上海市', '天津市', '重庆市']
function transformRegion(data: any) {
  return data.reduce((arr: any, province: any) => {
    // if (/台湾|香港|澳门/.test(province.name)) return arr
    return arr.concat({
      label: cityProvince.includes(province.name) ? province.name.replace(/(.)市$/, '$1') : province.name,
      value: cityProvince.includes(province.name) ? province.name.replace(/(.)市$/, '$1') : province.name,
      children: (province.cities?.length
        ? province.cities
        : [{ name: '', countries: [] }]
      ).map((city: any) => ({
        label: city.name,
        value: city.name,
        children: (city.counties?.length ? city.counties : ['']).map(
          (country: any) => ({
            label: country,
            value: country
          })
        ),
      })),
    })
  }, [] as any[])
}

const cascaderOptions = transformData(cities)

@Component({
  inheritAttrs: false,
  model: { event: 'change' }
})
export default class RegionCascader extends Vue {
  options:any = []
  async created() {
    const regionData = transformRegion((await axios('https://ecompic1.hitv.com/ecom/6/20fe5f8f80e97f56cebdeafdb3f7884b.txt')).data)
    this.options = [...regionData]
  }
  filter(query: string, path: any[]) {
    return path.map(option => option.label).join('').includes(query)
  }
}
